import * as controls from './controls';
import * as pages from './pages';
import type { MetadataInstanceInterface } from '../../common/decoration/factory';
import { MetadataFactory } from '../../common/decoration/factory';
import { DefinitionName, PageTypeV4 } from '@sap/ux-specification-types';

/**
 * Note: If the key of the elements corresponds to the name of the definition in schema, you do not have to list it explicitly here.
 * The following tables only comprise entries for elements that do not follow the official pattern (yet)
 */
const alpElements = {
    ALPTableView: controls.ALPTable
};

const lrElements = {
    ALPTableView: controls.ALPTable
};

const opElements = {
    [DefinitionName.ObjectPageTable]: controls.ObjectPageTable,
    [DefinitionName.TableCreationModeOP]: controls.TableCreationModeOP,
    TableColumn: controls.ObjectPageTableColumn,
    ObjectPageCustomSectionView: controls.ObjectPageCustomSectionFragment,
    ActionAfterExecutionConfiguration: controls.ActionAfterExecutionConfigurationOP
};

const pageTypes = {
    [PageTypeV4.AnalyticalListPage]: alpElements,
    [PageTypeV4.ListReport]: lrElements,
    [PageTypeV4.ObjectPage]: opElements
};

/**
 * V4 specific factory class for creating instances of (reflect) metadata classes
 */
export class MetadataInstanceFactoryV4 extends MetadataFactory implements MetadataInstanceInterface {
    constructor() {
        super(controls, pages, pageTypes);
    }
}
